module.exports = {"apis":{"aws":"https://dawa.aws.dk/","relevant":"https://worker31-api.relevant-digital.com/"}};